



























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import clientsModule from "@/store/modules/client-module";
import tiendaCartModule from "@/store/modules/tienda_cart_module";
import ventasCabeceraModule from "@/store/modules/ventas_cabecera-module";
import telemetriaClienteModule from "@/store/modules/telemetria_cliente-module";
import { DxChart, DxSeries, DxArgumentAxis, DxValueAxis, DxLegend, DxTooltip, DxLabel, DxGrid, DxBorder } from "devextreme-vue/chart";
import { DxPieChart, DxSeries as DxPieSeries, DxLabel as DxPieLabel, DxConnector } from "devextreme-vue/pie-chart";
import { DxFunnel, DxLabel as DxFunnelLabel } from "devextreme-vue/funnel";

@Component({
  components: { DxChart, DxSeries, DxArgumentAxis, DxValueAxis, DxLegend, DxTooltip, DxLabel, DxGrid, DxBorder, DxPieChart, DxPieSeries, DxPieLabel, DxConnector, DxFunnel, DxFunnelLabel }
})
export default class TelemetriaDashboard extends Vue {
  public cargando: boolean = false;

  get clientes() { return clientsModule.clientses || []; }
  get telemetrias() { return telemetriaClienteModule.telemetrias || []; }
  get carritos() { return tiendaCartModule.carts_loaded || []; }
  get presupuestos() { return (ventasCabeceraModule.ventasList || []).filter((v: any) => v.tipo_documento === 'presupuesto'); }

  get actividadMensual() {
    const mapa = new Map<string, { label: string, carritos: number, presupuestos: number, _ts: number }>();
    const agrupar = (lista: any[], field: string) => {
      lista.forEach(item => {
        if (!item.datecreated) return;
        const d = new Date(item.datecreated);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        if (!mapa.has(key)) {
          mapa.set(key, { label: d.toLocaleDateString("es-ES", { month: "short", year: "2-digit" }).toUpperCase(), carritos: 0, presupuestos: 0, _ts: new Date(d.getFullYear(), d.getMonth(), 1).getTime() });
        }
        (mapa.get(key) as any)[field]++;
      });
    };
    agrupar(this.carritos, 'carritos');
    agrupar(this.presupuestos, 'presupuestos');
    const today = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      if (!mapa.has(key)) {
        mapa.set(key, { label: d.toLocaleDateString("es-ES", { month: "short", year: "2-digit" }).toUpperCase(), carritos: 0, presupuestos: 0, _ts: d.getTime() });
      }
    }
    return Array.from(mapa.values()).sort((a, b) => a._ts - b._ts).slice(-12);
  }

  get topClientes() {
    const actMap = new Map<number, number>();
    this.carritos.forEach((c: any) => { if (c.client_id) actMap.set(c.client_id, (actMap.get(c.client_id) || 0) + 1); });
    this.presupuestos.forEach((p: any) => { if (p.client_id) actMap.set(p.client_id, (actMap.get(p.client_id) || 0) + 2); });
    return Array.from(actMap.entries()).map(([id, act]) => ({ id, act })).sort((a, b) => b.act - a.act).slice(0, 5).map(s => {
      const c = this.clientes.find((cl: any) => cl.id === s.id);
      return { id: s.id, name: c ? c.name : `ID: ${s.id}`, email: c ? c.email : '', actividad: s.act };
    });
  }

  get productosBuscadosReal() {
    const mapa = new Map<string, number>();
    this.telemetrias.filter(t => t.tipo_evento === 'busqueda' && t.texto_busqueda).forEach(b => { mapa.set(b.texto_busqueda, (mapa.get(b.texto_busqueda) || 0) + 1); });
    return Array.from(mapa.entries()).map(([categoria, busquedas]) => ({ categoria, busquedas })).sort((a, b) => b.busquedas - a.busquedas).slice(0, 10);
  }

  get diasSemanaReal() {
    const conteo = [0, 0, 0, 0, 0, 0, 0];
    this.telemetrias.filter(t => t.tipo_evento === 'page_view' && t.datecreated).forEach(v => { conteo[new Date(v.datecreated).getDay()]++; });
    return [
      { dia: 'Lunes', visitas: conteo[1] }, { dia: 'Martes', visitas: conteo[2] }, { dia: 'Miercoles', visitas: conteo[3] },
      { dia: 'Jueves', visitas: conteo[4] }, { dia: 'Viernes', visitas: conteo[5] }, { dia: 'Sabado', visitas: conteo[6] }, { dia: 'Domingo', visitas: conteo[0] }
    ];
  }

  get registrationTrend() {
    const counts = new Map<string, { label: string, count: number, timestamp: number }>();
    const today = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      counts.set(key, { label: d.toLocaleDateString("es-ES", { month: "short", year: "2-digit" }), count: 0, timestamp: d.getTime() });
    }
    for (const c of this.clientes) {
      if (!c.datecreated) continue;
      const d = new Date(c.datecreated);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      if (!counts.has(key)) counts.set(key, { label: d.toLocaleDateString("es-ES", { month: "short", year: "2-digit" }), count: 0, timestamp: new Date(d.getFullYear(), d.getMonth(), 1).getTime() });
      counts.get(key)!.count++;
    }
    const last12 = Array.from(counts.values()).sort((a, b) => a.timestamp - b.timestamp).slice(-12);
    return { labels: last12.map(m => m.label.toUpperCase()), values: last12.map(m => m.count) };
  }

  get funnelData() {
    const tv = this.telemetrias.filter(t => t.tipo_evento === 'page_view').length;
    const tb = this.telemetrias.filter(t => t.tipo_evento === 'busqueda').length;
    return [
      { step: "Visitas", value: tv > 0 ? tv : 100 }, { step: "Busquedas", value: tb > 0 ? tb : 40 },
      { step: "Carritos", value: this.carritos.length > 0 ? this.carritos.length : 15 },
      { step: "Presupuestos", value: this.presupuestos.length > 0 ? this.presupuestos.length : 5 }
    ];
  }

  get fuentesTraficoReal() {
    const counts = new Map<string, number>();
    const sesiones = new Set<string>();
    this.telemetrias.forEach(t => {
      if (!t.session_id || sesiones.has(t.session_id)) return;
      sesiones.add(t.session_id);
      let ref = 'Directo / Organico';
      if (t.referrer && t.referrer !== 'direct') {
        const lr = t.referrer.toLowerCase();
        if (lr.includes('whatsapp')) ref = 'WhatsApp';
        else if (lr.includes('instagram')) ref = 'Instagram';
        else if (lr.includes('facebook')) ref = 'Facebook';
        else if (lr.includes('google')) ref = 'Google';
        else ref = 'Referido (Otras webs)';
      }
      counts.set(ref, (counts.get(ref) || 0) + 1);
    });
    if (counts.size === 0) return [{ fuente: "Directo / Organico", count: 1 }];
    return Array.from(counts.entries()).map(([fuente, count]) => ({ fuente, count }));
  }

  get horariosActividadReal() {
    const horas = new Array(24).fill(0);
    this.telemetrias.forEach(t => { if (t.datecreated) horas[new Date(t.datecreated).getHours()]++; });
    if (Math.max(...horas) === 0) { horas[10]=5; horas[11]=8; horas[12]=12; horas[13]=10; horas[18]=15; horas[19]=25; horas[20]=18; }
    return horas.map((actividad, hora) => ({ hora: `${String(hora).padStart(2, '0')}:00`, actividad }));
  }

  get leadsCalientes() {
    const sessionMap = new Map<string, any>();
    this.telemetrias.forEach(t => {
      if (!t.session_id) return;
      if (!sessionMap.has(t.session_id)) sessionMap.set(t.session_id, { session_id: t.session_id, score: 0, producto_top: null, productos: new Map<number, number>(), referrer: 'direct', ultima_actividad: t.datecreated });
      const session = sessionMap.get(t.session_id);
      if (t.referrer && t.referrer !== 'direct') session.referrer = t.referrer;
      if (t.tipo_evento === 'page_view' && t.id_producto_wc) { session.score += 2; session.productos.set(t.id_producto_wc, (session.productos.get(t.id_producto_wc) || 0) + 1); }
      if (t.tipo_evento === 'busqueda') session.score += 5;
    });
    const leads = Array.from(sessionMap.values()).map(s => {
      if (s.referrer.includes('whatsapp') || s.referrer.includes('instagram')) s.score += 20;
      let maxViews = 0;
      s.productos.forEach((views: number, prodId: number) => { if (views > maxViews) { maxViews = views; s.producto_top = prodId; } });
      return s;
    });
    return leads.sort((a, b) => b.score - a.score).filter(l => l.score > 5).slice(0, 10);
  }

  get carritosAbandonados() {
    const ahora = new Date().getTime();
    return this.carritos.filter((c: any) => c.datecreated && (ahora - new Date(c.datecreated).getTime()) > 7200000 && !c.presupuesto_id).slice(0, 10);
  }

  public customizePieTooltip(arg: any) { return { text: `${arg.argumentText}: ${arg.valueText} busquedas` }; }

  public async cargarDatos() {
    this.cargando = true;
    try {
      await Promise.all([clientsModule.getclientses(), tiendaCartModule.getAllCarts(), ventasCabeceraModule.getVentas(), telemetriaClienteModule.getAll()]);
    } catch (e) { console.error("Error cargando telemetria", e); } finally { this.cargando = false; }
  }

  public async created() { await this.cargarDatos(); }
}
